export default __webpack_public_path__ + "static/media/cushion.099e6e13.webp";